var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4693_4174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6667H12.0067",
    stroke: "#008CD1",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33337V12",
    stroke: "#008CD1",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2067 5.33337C14.5603 5.33345 14.8994 5.47397 15.1494 5.72404L18.2747 8.84937C18.5248 9.09936 18.6653 9.43845 18.6654 9.79204V14.208C18.6653 14.5616 18.5248 14.9007 18.2747 15.1507L15.1494 18.276C14.8994 18.5261 14.5603 18.6666 14.2067 18.6667H9.7907C9.4371 18.6666 9.09802 18.5261 8.84803 18.276L5.7227 15.1507C5.47263 14.9007 5.33211 14.5616 5.33203 14.208V9.79204C5.33211 9.43845 5.47263 9.09936 5.7227 8.84937L8.84803 5.72404C9.09802 5.47397 9.4371 5.33345 9.7907 5.33337H14.2067Z",
    stroke: "#008CD1",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4693_4174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.00003)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIcon);
export default __webpack_public_path__ + "static/media/critical-icon.a439719b09abde919dd33d3b07029da0.svg";
export { ForwardRef as ReactComponent };